var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1684.912,
    height: 62.118,
    viewBox: "0 0 1684.912 62.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accounting2",
    transform: "translate(0 -19.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139427",
    "data-name": "\\uD328\\uC2A4 139427",
    d: "M-25.578-13.659l11.484-10.614c8.7-8,10.353-13.4,10.353-19.314,0-11.31-9.657-18.531-23.664-18.531-12.006,0-20.619,5.046-25.23,12.7l12.789,7.134A12.447,12.447,0,0,1-28.971-48.2c5.22,0,7.83,2.349,7.83,6.264,0,2.523-.7,5.307-5.568,9.831L-49.5-10.788V0H-2.088V-13.659Z",
    transform: "translate(1687 82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1662",
    "data-name": "\\uC120 1662",
    d: "M1610.908,1H0V-1H1610.908Z",
    transform: "translate(7.456 66.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21796",
    "data-name": "\\uD0C0\\uC6D0 21796",
    cx: 7.456,
    cy: 7.456,
    rx: 7.456,
    ry: 7.456,
    transform: "translate(0 59.388)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting2);
export default __webpack_public_path__ + "static/media/Accounting2.f60b36c8ff401eb0fd8f4deb512e6fe8.svg";
export { ForwardRef as ReactComponent };